<template>
	<div class="acesso-widget">
		<div class="label">Access count</div>
		<div class="count">
			<span class="total">{{ total }}</span> / <span class="max">{{ maximo }}</span>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['total', 'maximo']
	}
</script>


// WEBPACK FOOTER //
// src/components/Acessos.vue